import LoaderDirective from './LoaderDirective';
import ProgressDirective from './ProgressDirective';
import VisuallyHiddenDirective from './VisuallyHiddenDirective';
import 'portalConfig';

export default angular.module('edge.platform.widgets.loadingMsg', ['portal.config']).directive('gwLoader', LoaderDirective).directive('gwProgress', ProgressDirective).directive('gwVisuallyhiddenUnless', VisuallyHiddenDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/loading/module.js
// module id = 70
// module chunks = 0